import { Switch, cn } from "ui";
import { useField } from "../hooks/useField";
import { useFormFieldContext } from "./FormField";

interface SwitchFormFieldProps extends React.ComponentProps<typeof Switch> {
  children?: React.ReactNode;
  /**
   * Control value with string e.g. ENABLED || DISABLED
   */
  transform?: {
    value: (value: string) => boolean;
    onChange: (value: boolean) => string;
  };
  className?: string;
}

export function SwitchFormField({
  children,
  transform,
  className,
  ...props
}: SwitchFormFieldProps) {
  const {
    name,
    disabled,
    readOnly,
    required,
    defaultValue = false,
    validation,
    customValidation,
    descriptionId,
    errorMessageId,
    shouldUnregister,
  } = useFormFieldContext();

  const { ref, value, onChange, onBlur, error } = useField({
    name,
    defaultValue,
    validation,
    customValidation,
    shouldUnregister,
  });

  return (
    <Switch
      ref={ref}
      id={name}
      name={name}
      checked={transform ? transform.value(value) : value}
      onCheckedChange={(value) =>
        onChange(transform ? transform.onChange(value) : value)
      }
      onBlur={onBlur}
      className={cn(
        className,
        error &&
          "border-danger-bold focus:border-danger-bold focus:ring-danger-bold"
      )}
      disabled={disabled || readOnly}
      required={required}
      aria-describedby={
        !error ? `${descriptionId}` : `${descriptionId} ${errorMessageId}`
      }
      aria-invalid={!!error}
      {...props}
    >
      {children}
    </Switch>
  );
}
